<template>
  <div v-if="isLoading" class="content-spinner">
    <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
  </div>

  <div v-else-if="noServices" class="fill-height">
    <Toolbar />
    <NavigationDrawer />
    <NoServices></NoServices>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NoServices from '@/components/NoServices'
import Toolbar from '@/components/Toolbar.vue'
import NavigationDrawer from '@/components/NavigationDrawer'

export default {
  name: 'Home',

  components: {
    NoServices,
    Toolbar,
    NavigationDrawer
  },

  data() {
    return {
      noServices: false
    }
  },

  computed: {
    ...mapGetters({
      error: 'connectagreement/list/error',
      agreements: 'connectagreement/list/items',
      isLoading: 'connectagreement/list/isLoading',
      view: 'connectagreement/list/view'
    })
  },

  watch: {
    agreements: function(agreements) {
      let activatedAgreement = null
      if (agreements && agreements.length > 0) {
        agreements.forEach(agreement => {
          if (
            agreement.startsAt &&
            this.$moment() > this.$moment(agreement.startsAt) &&
            (!agreement.endsAt || !this.$moment() < this.$moment(agreement.endsAt))
          ) {
            activatedAgreement = agreement
          }
        })
      }

      if (activatedAgreement) {
        this.$router.push({
          name: 'AgreementShow',
          params: {
            id: this.$iriToId(activatedAgreement['@id'])
          }
        })
      } else {
        this.noServices = true
      }
    }
  }
}
</script>
